import React, { Component } from "react";
//import WordSearchHeading from './WordSearchHeading';
import WordSearchStatisticsSimple from "./WordSearchStatisticsSimple";
import ItemHint from "./ItemHint";
//import ReactTooltip from 'react-tooltip'
import ReactTable from "react-table";
import "react-table/react-table.css";

export default class WordSearchResultsSimple extends Component {
  showTheTing = (itemid) => {
    window.open(
      "/just/" + itemid,
      "_blank",
      "status=no, menubar=no, width=800,height=800"
    );
  };

  render() {
    const columns = [
      {
        Header: "Type",
        id: "wordType",
        accessor: (d) => d.wordsortcontent,
      },
      {
        Header: "Token",
        id: "wordContent",
        accessor: (d) => d.wordcontent,
      },
      {
        Header: "Line",
        id: "lineContent",
        accessor: (d) => d.plcontentwithnumber,
        Cell: (props) => {
          return <span style={{ whiteSpace: "pre" }}>{props.value}</span>;
        },
      },
      {
        Header: "Document",
        id: "document",
        accessor: (d) => d.defaultsort,
        Cell: (props) => {
          return (
            <a
              style={{ cursor: "pointer" }}
              onClick={() => this.showTheTing(props.original.itemid)}
            >
              {props.original.itemheading}
            </a>
          );
        },
      },
      {
        Header: "Hand",
        id: "writer",
        accessor: (d) => d.writers,
      },
      {
        Header: "Chronology",
        id: "chronology",
        accessor: (d) => d.chronology,
        Cell: (props) => {
          return <span style={{ whiteSpace: "pre" }}>{props.value}</span>;
        },
      },
      {
        Header: "Find-area",
        id: "findarea",
        accessor: (d) => d.findarea,
        Cell: (props) => {
          return <span style={{ whiteSpace: "pre" }}>{props.value}</span>;
        },
      },
      {
        Header: "",
        id: (d) => d.itemid,
        accessor: (d) => d,
        Cell: (props) => (
          <div style={{ textAlign: "right" }}>
            <ItemHint data={props.value.itemid} />
          </div>
        ),
      },
    ];
    const defaultSorted = [
      {
        id: "document",
        desc: false,
      },
    ];

    return (
      <div className="col-md-12 wordsearchresults">
        <div className="row">
          <div>
            {this.props.isLoading ? (
              <p className="lead">Loading...</p>
            ) : this.props.results.statistics ? (
              <WordSearchStatisticsSimple
                data={this.props.results.hits}
                stats={this.props.results.statistics}
              />
            ) : null}
          </div>

          <div className="panel panel-default">
            <div className="panel-body">
              <ReactTable
                ref={this.setTableRef}
                className="-striped -highlight"
                showPagination={false}
                loading={this.props.isLoading}
                pageSize={
                  this.props.results.hits !== undefined
                    ? this.props.results.hits.length
                    : 1
                }
                minRows={1}
                data={this.props.results.hits}
                columns={columns}
                defaultSorted={defaultSorted}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/WordSearchResultsSimple.jsx